import { render, staticRenderFns } from "./TransferSKUItem.vue?vue&type=template&id=40095a8b&"
import script from "./TransferSKUItem.vue?vue&type=script&lang=js&"
export * from "./TransferSKUItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports